module.exports = __webpack_public_path__ + "img/theature.173b2c8c.jpg";